import React, { useMemo } from 'react'

import { Button, Section, useModalContext } from '@sketch/components'

import DeleteAccountModal from './DeleteAccountModal'
import {
  UserOwnsWorkspacesModal,
  SocialDeleteAccountModal,
} from '../../../../modals'
import { UserWorkspaceMembershipFragment } from '@sketch/gql-types'

type OtherOptionsPanelProps = {
  hasPersonalIdentity: boolean
  isSocialSignInOnly: boolean
  memberships: UserWorkspaceMembershipFragment[]
}
export const OtherOptionsPanel = ({
  hasPersonalIdentity,
  isSocialSignInOnly,
  memberships,
}: OtherOptionsPanelProps) => {
  const { showModal } = useModalContext()

  const userOwnedWorkspace = useMemo(
    () =>
      memberships.filter(
        (membership: UserWorkspaceMembershipFragment) =>
          membership.workspace.userIsOwner
      ),
    [memberships]
  )

  /* Avoid a scenario where only the "Other" title was being rendered */
  if (!hasPersonalIdentity) {
    return null
  }

  const handleClick = () => {
    /** User needs to delete or transfer workspaces first */
    if (userOwnedWorkspace.length > 0) {
      const workspaceIdentifier = userOwnedWorkspace[0]?.workspace?.identifier

      showModal(UserOwnsWorkspacesModal, {
        workspaceIdentifier,
      })
      return
    }

    if (isSocialSignInOnly) {
      /** User only has Social sign in method and needs to auth again with the provider */
      showModal(SocialDeleteAccountModal)
      return
    }

    /** User has at least one U+P account associated, we render the regular U+P modal */
    showModal(DeleteAccountModal)
  }

  return (
    <Section id="delete-account-header" title="Other">
      <Button variant="negative" size="40" onClick={handleClick}>
        Delete Account&hellip;
      </Button>
    </Section>
  )
}
